module.exports = __webpack_public_path__ + "static/img/demo-map@2x.aa729e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/app-demo/images/demo-map@2x.png
// module id = L52I
// module chunks = 12